import { pxToRem } from '../../../../utils';
export default (function (siteVariables) {
  return {
    background: siteVariables.bodyBackground,
    color: siteVariables.bodyColor,
    scrollbarHeight: pxToRem(16),
    scrollbarWidth: pxToRem(16),
    scrollbarThumbBackgroundColor: siteVariables.colors.grey[250],
    scrollbarThumbBorderRadius: pxToRem(9),
    scrollbarThumbBorderSize: pxToRem(4),
    scrollbarThumbHoverBackgroundColor: siteVariables.colors.grey[350],
    scrollbarThumbHoverBorderSize: pxToRem(2)
  };
});